import Title from './title'
import AboutBlock from './block-about'
import ApplyPanel from './panel'

export default function Studios({ studios }) {
  const t = useI18n()
  const cityAll = t('page:joinUs.studios.cityAll')
  const { state, mutate } = useStatic({ currentCity: cityAll, filteredStudios: studios })
  const cities = studios.map(studio => studio.city).uniq()
  cities.unshift(cityAll)

  const renderStudios = () => state.filteredStudios.map(studio => (
    <Studio
      key={ studio.name }
      studio={ studio }
    />
  ))

  const onCityClick = city => {
    state.currentCity = city
    if (city === cityAll) state.filteredStudios = studios
    else state.filteredStudios = studios.filter(studio => studio.city === city)
    mutate()
  }

  const renderCities = () => <div className='flex flex-wrap text-sm pb-3 mt-3'>
    { cities.map(city =>
      <div
        key={ city }
        className={ cn('border-[1px] mr-2 mb-3 py-2 px-4 rounded-md whitespace-nowrap cursor-pointer', { 'bg-black text-white': city === state.currentCity }) }
        onClick={ () => onCityClick(city) }>{city}
      </div>
    ) }
  </div>

  return (
    <AboutBlock>
      <Title>{ t('page:joinUs.studios.title') }</Title>
      { renderCities() }
      <div className='grid grid-cols-1 gap-10 md:grid-cols-3 mt-2'>
        { renderStudios() }
      </div>
      <ApplyPanel/>
    </AboutBlock>
  )
}

const Studio = ({ studio }) => (
  <div className='flex flex-col space-y-4'>
    <div className='relative'>
      <C.Image
        className='w-full aspect-[2/1] rounded-[4px]'
        src={ studio.bannerUrl }
      />
      <div className='absolute top-1 left-1 bg-gray-100 bg-opacity-90 text-gray-900 text-xs p-1 tracking-widest rounded'>{ studio.$recruitStatus }</div>
    </div>
    <div>
      <div className='font-bold text-lg md:text-sm truncate'>{ studio.name }</div>
      <div className='flex space-x-2 justify-between mt-2 items-center'>
        <div className='text-gray-500 md:text-xs'>{ studio.address }</div>
        <div className='shrink-0 pb-1 md:pt-1'><C.Button className='w-full' onClick={ () => h.openJoinUsApply(studio.id) }>{ studio.$btnText }</C.Button></div>
      </div>
    </div>
  </div>
)
